/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DeliverReturnHistoryResultFromJSON, DeliverReturnHistoryResultToJSON, } from './';
export function DeliverReturnHistoryResultPagedResultFromJSON(json) {
    return DeliverReturnHistoryResultPagedResultFromJSONTyped(json, false);
}
export function DeliverReturnHistoryResultPagedResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'positions': !exists(json, 'positions') ? undefined : (json['positions'] === null ? null : json['positions'].map(DeliverReturnHistoryResultFromJSON)),
        'hasNextPage': !exists(json, 'hasNextPage') ? undefined : json['hasNextPage'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}
export function DeliverReturnHistoryResultPagedResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'positions': value.positions === undefined ? undefined : (value.positions === null ? null : value.positions.map(DeliverReturnHistoryResultToJSON)),
        'hasNextPage': value.hasNextPage,
        'page': value.page,
        'limit': value.limit,
    };
}
